__turbopack_context__.v({
  "card": "SuggestionsCarousel-module__34hFoa__card",
  "carousel": "SuggestionsCarousel-module__34hFoa__carousel",
  "container": "SuggestionsCarousel-module__34hFoa__container",
  "controlsContainer": "SuggestionsCarousel-module__34hFoa__controlsContainer",
  "subsetStart": "SuggestionsCarousel-module__34hFoa__subsetStart",
  "titleContainer": "SuggestionsCarousel-module__34hFoa__titleContainer",
  "track": "SuggestionsCarousel-module__34hFoa__track",
});
